import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    paddingVertical: 4,
    paddingLeft: 4,
  },

  text: {
    textAlign: 'right',
    backgroundColor: 'transparent',
  },
});



// WEBPACK FOOTER //
// ./src/components/third-party/Textfield/src/components/counter/styles.js